"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFaxNumberForEntrata = void 0;
var libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
var transformFaxNumberForEntrata = function (faxNumber) {
    if (!faxNumber)
        return '';
    var faxNumberObject = (0, libphonenumber_js_1.default)(faxNumber);
    if (!faxNumberObject)
        return '';
    var nationalNumber = faxNumberObject.nationalNumber;
    return nationalNumber;
};
exports.transformFaxNumberForEntrata = transformFaxNumberForEntrata;
